module.exports = __webpack_public_path__ + "img/banner.daca2c75.jpg";